module.exports = __webpack_public_path__ + "static/media/SFX_Crowd_Chatter.bff2092f.mp3";